/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const e = "pdfviewer.zoomIn", o = "pdfviewer.zoomOut", t = "pdfviewer.zoomLevel", n = "pdfviewer.enableSelection", c = "pdfviewer.enablePanning", i = "pdfviewer.search", a = "pdfviewer.open", p = "pdfviewer.download", s = "pdfviewer.print", d = "pdfviewer.close", r = "pdfviewer.matchCase", l = "pdfviewer.prevMatch", v = "pdfviewer.nextMatch", w = "pdfviewer.actualWidth", f = "pdfviewer.fitToWidth", h = "pdfviewer.fitToPage", m = "pdfviewer.popupBlocked", u = {
  [e]: "Zoom in",
  [o]: "Zoom out",
  [t]: "Choose zoom level",
  [n]: "Enable selection",
  [c]: "Enable panning",
  [i]: "Search",
  [a]: "Open",
  [p]: "Download",
  [s]: "Print",
  [d]: "Close",
  [r]: "Match case",
  [l]: "Previous match",
  [v]: "Next match",
  [w]: "Actual width",
  [f]: "Fit to width",
  [h]: "Fit to page",
  [m]: "Popup is blocked."
};
export {
  w as actualWidth,
  d as close,
  p as download,
  c as enablePanning,
  n as enableSelection,
  h as fitToPage,
  f as fitToWidth,
  r as matchCase,
  u as messages,
  v as nextMatch,
  a as open,
  m as popupBlocked,
  l as prevMatch,
  s as print,
  i as search,
  e as zoomIn,
  t as zoomLevel,
  o as zoomOut
};
